import { queryClient } from 'src'

export function invalidateVesselCertificateQueries(vesselId: string) {
  queryClient.invalidateQueries({
    queryKey: [`/vessels/${vesselId}`],
  })
  queryClient.invalidateQueries({
    queryKey: ['/vessels'],
  })
}
